import React, { FC, memo } from 'react'
import { camelCase } from 'lodash'
import { BasicInfo } from 'types'

export interface IToolFlyoutPopupProps {
  option: BasicInfo
  handleClick: (param: string) => void
}

const FlyOutTabs: FC<IToolFlyoutPopupProps> = ({ option, handleClick }) => {
  return (
    <div className="flex  pl-2 pr-5 py-3 max-w-[240px]">
      <p
        className="!text-primary-text !border-0 !text-base !font-[650] overflow-hidden cursor-pointer"
        onClick={() => handleClick(camelCase(option.title.trim()))}
      >
        {option.title}
      </p>
    </div>
  )
}

export default memo(FlyOutTabs)
